export default "__VITE_ASSET__M$ylURoK__"